import { TickIcon } from "@multiply/lib";

const Completed = () => (
    <div className="rounded-full bg-radio-selected-border h-28 w-28 flex justify-center items-center">
      <TickIcon variant="white" />
    </div>
  );

  export {Completed}